(() => {
  const rootSelector = "#sovah-routine-quiz";
  const buttonSelector = "[data-action='add-to-cart'][data-variant-id]";
  const checks = new Map();

  const words = (root) => {
    const active = root.querySelector("[data-lang].is-active")?.dataset.lang ||
      (document.documentElement.lang || "en").slice(0, 2).toLowerCase();
    if (active === "nl") return {
      out: "Uitverkocht", unavailable: "Dit product is momenteel niet op voorraad.", email: "Je e-mailadres",
      notify: "Meld je aan voor voorraadupdates", notifying: "Aanmelden...", notified: "Aanmelding ontvangen. We bewaren je aanvraag voor dit product.",
      notifyError: "Aanmelden is niet gelukt. Probeer het opnieuw.", adding: "Toevoegen...", added: "Toegevoegd aan winkelwagen.", error: "Toevoegen mislukt. Probeer opnieuw."
    };
    if (active === "de") return {
      out: "Ausverkauft", unavailable: "Dieses Produkt ist derzeit nicht auf Lager.", email: "Deine E-Mail-Adresse",
      notify: "Für Bestandsupdates anmelden", notifying: "Anmeldung...", notified: "Anmeldung erhalten. Wir speichern deine Anfrage für dieses Produkt.",
      notifyError: "Die Anmeldung ist fehlgeschlagen. Bitte versuche es erneut.", adding: "Wird hinzugefügt...", added: "Zum Warenkorb hinzugefügt.", error: "Hinzufügen fehlgeschlagen. Bitte versuche es erneut."
    };
    return {
      out: "Out of stock", unavailable: "This product is currently unavailable.", email: "Your email address",
      notify: "Sign up for stock updates", notifying: "Signing up...", notified: "Signup received. We saved your request for this product.",
      notifyError: "Signup failed. Please try again.", adding: "Adding...", added: "Added to cart.", error: "Could not add to cart. Please try again."
    };
  };

  const productUrl = (button) => {
    const link = button.closest(".sovah-result-card")?.querySelector(".sovah-result-actions a[href*='/products/']");
    return link ? new URL(link.href, location.origin) : null;
  };

  async function available(button) {
    const url = productUrl(button);
    const variantId = button.dataset.variantId;
    if (!url || !variantId) return true;
    const key = url.pathname + ":" + variantId;
    if (!checks.has(key)) checks.set(key, (async () => {
      url.search = "";
      url.hash = "";
      url.pathname = url.pathname.replace(/\.js$/, "") + ".js";
      const response = await fetch(url, { headers: { Accept: "application/json" }, cache: "no-store" });
      if (!response.ok) throw new Error("Stock check failed");
      const product = await response.json();
      const variant = product.variants?.find((item) => String(item.id) === String(variantId));
      return Boolean(variant?.available ?? product.available);
    })());
    try { return await checks.get(key); }
    catch (error) { console.warn("SOVAH quiz stock:", error); checks.delete(key); return true; }
  }

  function soldOut(button, root) {
    const text = words(root);
    const handle = productUrl(button)?.pathname.split("/").filter(Boolean).pop() || "product";
    const box = document.createElement("div");
    box.className = "sovah-stock-status";
    box.setAttribute("role", "status");
    box.innerHTML = "<strong>" + text.out + "</strong><br>" + text.unavailable +
      '<form class="sovah-stock-form" method="post" action="/contact#sovah-stock-notify">' +
      '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="newsletter, stock-alert, quiz-stock-alert, ' + handle + '">' +
      '<input type="hidden" name="contact[accepts_marketing]" value="true">' +
      '<input type="hidden" name="contact[body]" value="Stock alert: ' + handle + '">' +
      '<input type="email" name="contact[email]" required autocomplete="email" aria-label="' + text.email + '" placeholder="' + text.email + '">' +
      '<button class="sovah-link-btn sovah-link-btn-primary" type="submit">' + text.notify + '</button>' +
      '<span class="sovah-stock-form-feedback" role="status" aria-live="polite"></span></form>';
    button.replaceWith(box);
  }

  async function submitStockForm(form, root) {
    const text = words(root);
    const submit = form.querySelector("button[type='submit']");
    const status = form.querySelector(".sovah-stock-form-feedback");
    submit.disabled = true;
    submit.textContent = text.notifying;
    status.textContent = "";
    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "text/html" },
        credentials: "same-origin"
      });
      if (!response.ok) throw new Error("Stock signup failed");
      form.querySelector("input[type='email']").disabled = true;
      submit.hidden = true;
      status.textContent = text.notified;
    } catch (error) {
      console.error("SOVAH stock signup:", error);
      status.textContent = text.notifyError;
      submit.disabled = false;
      submit.textContent = text.notify;
    }
  }

  async function inspect(root) {
    for (const button of root.querySelectorAll(buttonSelector)) {
      if (button.dataset.stockCheck) continue;
      button.dataset.stockCheck = "pending";
      if (!(await available(button))) soldOut(button, root);
      else button.dataset.stockCheck = "available";
    }
  }

  function feedback(root, message) {
    let box = root.querySelector(".sovah-cart-feedback");
    if (!box) {
      box = document.createElement("div");
      box.className = "sovah-cart-feedback";
      root.querySelector(".sovah-results-grid")?.after(box);
    }
    box.textContent = message;
  }

  async function add(button, root) {
    const text = words(root);
    const variantId = button.dataset.variantId;
    button.disabled = true;
    feedback(root, text.adding);
    try {
      if (!(await available(button))) { soldOut(button, root); return; }
      const sections = [...document.querySelectorAll("cart-items-component[data-section-id]")].map((el) => el.dataset.sectionId).filter(Boolean);
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: [...new Set(sections)], sections_url: location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || "Cart add failed");
      document.dispatchEvent(new CustomEvent("cart:update", {
        bubbles: true,
        detail: { resource: cart, sourceId: "sovah-routine-quiz", data: { source: "sovah-routine-quiz", variantId: String(variantId), sections: cart.sections || {} } }
      }));
      feedback(root, text.added);
    } catch (error) {
      console.error("SOVAH quiz cart:", error);
      feedback(root, text.error);
    } finally {
      if (button.isConnected) button.disabled = false;
    }
  }

  const style = document.createElement("style");
  style.textContent = ".sovah-stock-status{width:100%;margin-top:10px;padding:10px 12px;border:1px solid rgba(245,241,232,.14);border-radius:12px;background:rgba(245,241,232,.05);font-size:13px;line-height:1.45}.sovah-stock-status strong{color:#f0b8ad}.sovah-stock-form{display:flex;flex-wrap:wrap;gap:8px;width:100%;margin-top:10px}.sovah-stock-form input[type=email]{min-width:210px;flex:1 1 210px;min-height:44px;border-radius:12px;border:1px solid rgba(245,241,232,.1);background:#1f1f1f;color:#f5f1e8;padding:0 12px;font:inherit}.sovah-stock-form-feedback{flex:1 0 100%;color:#9fc1ba}.sovah-link-btn[disabled]{opacity:.52;cursor:not-allowed}";
  document.head.appendChild(style);

  function init() {
    const root = document.querySelector(rootSelector);
    if (!root) return;
    inspect(root);
    new MutationObserver(() => inspect(root)).observe(root, { childList: true, subtree: true });
    root.addEventListener("click", (event) => {
      const button = event.target.closest(buttonSelector);
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      add(button, root);
    }, true);
    root.addEventListener("submit", (event) => {
      const form = event.target.closest(".sovah-stock-form");
      if (!form) return;
      event.preventDefault();
      submitStockForm(form, root);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
